export interface LogRetentionConfig {
    maxEntries: number;
    maxAgeMs: number;
    diagnosticMode?: boolean;
}

export const defaultLogRetentionConfig: LogRetentionConfig = {
    maxEntries: 5000,
    maxAgeMs: 14 * 24 * 60 * 60 * 1000,
    diagnosticMode: false
}
